<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-guest"
      entity-name="嘉宾"
      add-btn="添加嘉宾"
      hide-show-detail
      :custom-url="customUrl"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:button v-if="editable">
        <a-button @click="importGuest"><a-icon type="upload" />批量导入</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入嘉宾姓名或手机号查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入嘉宾姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入嘉宾手机号码"></a-input>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <a-select v-model="form.sex" :options="genderList" placeholder="请选择嘉宾性别"></a-select>
        </a-form-model-item>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="嘉宾邀请导入模板.xlsx"
      url="https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/guest_invite_template.xlsx"
      import-url="/activity/activity-guest/import"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import {genderList, getGenderText} from "../../../common/activity/guest";
    import batchImportModal from "../../../components/batch-import-modal";
    import mixins from "../mixins";

    export default {
        name: "GuestInvite",
        components: {
            batchImportModal
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                    {title: '性别', dataIndex: 'sex', customRender: text => getGenderText(text)},
                    {title: '填报状态', dataIndex: 'fill_status', customRender: text => text == 2 ? '已填报' : '未填报'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入嘉宾姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入嘉宾手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    sex: [{ required: true, message: '请选择嘉宾性别', trigger: 'change' }],
                },
                genderList,
                visible: false,
                moduleKey: 'guest-verify',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&filter[f_id]=0';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                    form.type = 1;
                }
                fn();
            },
            importGuest() {
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
